import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { getShouldShowContactInformation } from "../../store";
import { contactInformationMessage } from "../../lib/constants";

const ContactWarning = () => {
  const showContactInformationMessage = useSelector(getShouldShowContactInformation);

  if (!showContactInformationMessage) {
    return null;
  }
  return (
    <div className="contactInformation" style={{ fontSize: "10px" }}>
      {contactInformationMessage}
    </div>
  );
};

export default ContactWarning;
